// src/components/SuccessAnimation.js
import React from 'react';
import Lottie from 'lottie-react';
import successAnimation from './AnimatedSuccess.json'; // Adjust the path according to your project structure

const SuccessAnimation = ({ className }: any) => {
  return (
    <div>
      <Lottie className={className} animationData={successAnimation} loop={false} />
    </div>
  );
};

export default SuccessAnimation;
